import React, { useEffect, useState } from 'react';
import { Popup } from 'devextreme-react/popup';
import { useAppSelector } from '../../../../../contexts/hooks';
import { useApiOrders } from '../../../../../api/api.orders';
import { useScreenSize } from '../../../../../utils/media-query';
import { SampleTubesPanel, TmBcListDTO } from './SampleTubesPanel';

interface ModalSampleTubesProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
}

export const ModalSampleTubes: React.FC<ModalSampleTubesProps> = ({ visible, setVisible }) => {
  const { isXSmall } = useScreenSize();
  const { GetSampleTypeAndBarcode } = useApiOrders();
  const addedStudies = useAppSelector((x) => x.globalOrders.CurrentOrder.StudiesData);
  const [sampleTubesData, setSampleTubesData] = useState<TmBcListDTO[]>([]);

  useEffect(() => {
    if (!visible) {
      setSampleTubesData([]);
      return;
    }
    const studyIds = addedStudies.map((s) => s.Es_Id);
    if (studyIds.length === 0) return;
    GetSampleTypeAndBarcode(studyIds).then((res: TmBcListDTO[]) => {
      setSampleTubesData(res || []);
    });
  }, [visible]);

  return (
    <Popup
      visible={visible}
      onHiding={() => setVisible(false)}
      dragEnabled={false}
      hideOnOutsideClick={true}
      showCloseButton={true}
      showTitle={true}
      title='Muestras'
      width={isXSmall ? '100%' : 400}
      height='auto'
      fullScreen={isXSmall}
    >
      <SampleTubesPanel data={sampleTubesData} />
    </Popup>
  );
};
